/**
 * Editorial Blog System JS
 * Logic for search, sharing, and interactions.
 */

document.addEventListener('DOMContentLoaded', () => {
    initEditorialSearch();
    initEditorialShare();
});

/**
 * Editorial Search Interaction
 */
function initEditorialSearch() {
    const searchInput = document.querySelector('.dr-editorial--search-input');
    if (!searchInput) return;

    searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            const query = searchInput.value.trim();
            if (query) {
                // Perform standard Shopify search redirect
                window.location.href = `/search?type=article&q=${encodeURIComponent(query)}`;
            }
        }
    });

    // Optional: Real-time filtering could be added here for the current page
}

/**
 * Editorial Social Sharing
 */
function initEditorialShare() {
    const shareBtns = document.querySelectorAll('.dr-editorial--share-btn');
    if (!shareBtns.length) return;

    shareBtns.forEach(btn => {
        const type = btn.getAttribute('data-share');
        if (!type) return;

        btn.addEventListener('click', (e) => {
            if (type === 'copy') {
                e.preventDefault();
                const url = window.location.href;
                navigator.clipboard.writeText(url).then(() => {
                    const originalHTML = btn.innerHTML;
                    btn.innerHTML = '✓';
                    btn.classList.add('is-copied');
                    setTimeout(() => {
                        btn.innerHTML = originalHTML;
                        btn.classList.remove('is-copied');
                    }, 2000);
                }).catch(err => {
                    console.error('Copy link failed:', err);
                });
            }
            // Other sharing types (Facebook, Twitter, LinkedIn) use native <a> tag attributes
        });
    });
}
